import { faFolders } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  EmptyState as EmptyStateAtom,
  EmptyStateIcon,
  Content,
  EmptyStateContainer as EmptyStateContainerAtom,
} from 'components/atoms/empty-state';
// import { KBLinks } from 'constant';

const EmptyState = styled(EmptyStateAtom)`
  && {
    width: 632px;
    max-width: 648px;
    background-color: transparent;
    box-shadow: none;
    ${Content} {
      width: 544px;
    }
  }
`;

const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  && {
    padding: var(--spacing-07) var(--spacing-05);
  }
`;

export const SpaceTabEmptyState: FC = () => (
  <EmptyStateContainer>
    <EmptyState
      direction="horizontal"
      image={<EmptyStateIcon icon={faFolders} />}
      title={<FormattedMessage id="space_tab.empty.title" />}
      message={<FormattedMessage id="space_tab.empty.message" />}
      // secondaryCTA={
      //   <EmptyState.CallToAction.Secondary
      //     href={KBLinks.addingDocumentToProject}
      //     target="_blank"
      //   >
      //     <FormattedMessage id="space_tab.empty.secondary" />
      //   </EmptyState.CallToAction.Secondary>
      // }
    />
  </EmptyStateContainer>
);
